import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { TabsRouter } from '../../components/generic/TabsRouter';
import { ContentLayout } from '../../components/layouts/ContentLayout';
import { BasicSettings } from './BasicSettings';
import { FieldSettings } from './FieldSettings';
import { FormSettings } from './FormSettings';
import { IncidentCategorySettings } from './IncidentCategorySettings';
import { LabelSettings } from './LabelSettings';
import { LocationSettings } from './LocationSettings';
import { SecuritySettings } from './SecuritySettings';
import { TaskTemplateSettings } from './TaskTemplateSettings';

export const Settings = () => {
  const routes = [
    'basic',
    'security',
    'incidents',
    'locations',
    'fields',
    'labels',
    'forms',
    'tasks',
  ];

  return (
    <ContentLayout
      headerContent={
        <ChakraV3.Heading size='3xl' fontWeight='bold'>
          Settings
        </ChakraV3.Heading>
      }
    >
      <TabsRouter
        routes={routes}
        defaultValue={routes[0]}
        variant='subtle'
        orientation='vertical'
        size='sm'
        w='full'
        h='full'
        lazyMount
        unmountOnExit
      >
        <ChakraV3.Tabs.List minW='120px' flexShrink={0} py={2} ml={6}>
          <ChakraV3.Tabs.Trigger value='basic'>Basic</ChakraV3.Tabs.Trigger>
          <ChakraV3.Tabs.Trigger value='security'>Security</ChakraV3.Tabs.Trigger>
          <ChakraV3.Tabs.Trigger value='incidents'>Incidents</ChakraV3.Tabs.Trigger>
          <ChakraV3.Tabs.Trigger value='locations'>Locations</ChakraV3.Tabs.Trigger>
          <ChakraV3.Tabs.Trigger value='fields'>Fields</ChakraV3.Tabs.Trigger>
          <ChakraV3.Tabs.Trigger value='tasks'>Tasks</ChakraV3.Tabs.Trigger>
          <ChakraV3.Tabs.Trigger value='labels'>Labels</ChakraV3.Tabs.Trigger>
          <ChakraV3.Tabs.Trigger value='forms'>Forms</ChakraV3.Tabs.Trigger>
        </ChakraV3.Tabs.List>
        <ChakraV3.Tabs.ContentGroup overflowY='auto' h='full' w='full' px={6} py={2}>
          <ChakraV3.Tabs.Content value='basic'>
            <BasicSettings />
          </ChakraV3.Tabs.Content>
          <ChakraV3.Tabs.Content value='security'>
            <SecuritySettings />
          </ChakraV3.Tabs.Content>
          <ChakraV3.Tabs.Content value='incidents'>
            <IncidentCategorySettings />
          </ChakraV3.Tabs.Content>
          <ChakraV3.Tabs.Content value='locations'>
            <LocationSettings />
          </ChakraV3.Tabs.Content>
          <ChakraV3.Tabs.Content value='fields'>
            <FieldSettings />
          </ChakraV3.Tabs.Content>
          <ChakraV3.Tabs.Content value='tasks'>
            <TaskTemplateSettings />
          </ChakraV3.Tabs.Content>
          <ChakraV3.Tabs.Content value='labels'>
            <LabelSettings />
          </ChakraV3.Tabs.Content>
          <ChakraV3.Tabs.Content value='forms'>
            <FormSettings />
          </ChakraV3.Tabs.Content>
        </ChakraV3.Tabs.ContentGroup>
      </TabsRouter>
    </ContentLayout>
  );
};
